import { Component, OnInit, Input } from '@angular/core';
import { ModalService } from '@myServices/modal.service';
import { NotificationService } from '@myServices/notification.service';
import { OverlayService } from '@myServices/overlay.service';
import { GameService } from "@myServices/game.service";
import { DomSanitizer } from '@angular/platform-browser';
import { GameComponent } from '../game/game.component';
import {LocalService} from "@Shared/services";


@Component({
  selector: 'app-mg-wallet',
  templateUrl: './mg-wallet.component.html',
  styleUrls: ['./mg-wallet.component.css']
})
export class MgWalletComponent implements OnInit {

  @Input() isMobile: Boolean;
  @Input() public MicroGamingBalance;
  @Input() public GeneralBalance;
  @Input() public Currency;
  @Input() public isMicroGaming;
  @Input() public microGamingGame;
  @Input() public fromMobile: Boolean;

  public amount: string;
  public processing = false;
  public action = 'deposit';
  private currentUrl: string;
  private currentLanguage: string;

  constructor(
    private modalService: ModalService,
    private notificationService: NotificationService,
    private overlayService: OverlayService,
    private gameService: GameService,
    private domSanitizer: DomSanitizer,
    private localService: LocalService
  ) { }

  ngOnInit() {
    this.currentUrl = location.href;
    this.currentLanguage = this.localService.currentLang;
    this.getMicroGamingBalance();
  }
  public close() {
    document.body.classList.remove('game-modal-header');
    this.modalService.destroy();
  }

  public onKey(event, newValue) {
    this.amount = newValue;
  }

  public selectAction(event) {
    console.log(event.target.value);
    this.action = event.target.value;
  }


  getMicroGamingBalance() {
    this.processing = true;
    this.gameService.getMicroGamingBalance().subscribe(resp => {
      if (resp.status === true) {
        this.MicroGamingBalance = resp.data.wallet.balance;
        this.GeneralBalance = resp.data.user.balance;
        this.Currency = resp.data.user.currency;
        this.processing = false;
      }
    });
  }

  setAction() {
    this.processing = true;
    let data = {
      amount: this.amount,
      action: this.action,

    };
    if(this.microGamingGame){
      data['game_id'] = this.microGamingGame['id']
    }
    else{
      data['game_id'] = 0;
    }
    this.gameService.setMicroGamingAction(data).subscribe(resp => {
      if (resp.data.wallet !== undefined) {
        this.MicroGamingBalance = resp.data.wallet.balance;
      }
      this.GeneralBalance = resp.data.user.balance;
      this.processing = false;
      if (resp.status === true) {
        this.notificationService.success(resp.messages[0]);
        if (this.isMicroGaming) {
          this.close();
          this.getMicroGamingGameAfterDeposit();
        }
      }
      else {
        this.notificationService.error(resp.messages[0]);
      }
      this.action = 'deposit';
      this.amount = '0';
    });
  }

  getMicroGamingGameAfterDeposit() {
    this.overlayService.onOverlayChange(true);
    if (this.fromMobile) {
      this.gameService.getGameInfo(this.microGamingGame.id, true, this.currentUrl, this.currentLanguage).subscribe(resp => {
        if (!resp.status) {
          this.overlayService.onOverlayChange(false);
          return this.notificationService.error(resp.messages[0]);
        }
          let url = resp.data.gameData.iframeUrl;
          location.href = url;
      });
    }
    else{
      this.gameService.getGameInfo(this.microGamingGame.id, false, this.currentUrl, this.currentLanguage).subscribe(resp => {
        if (!resp.status) {
          this.overlayService.onOverlayChange(false);
          return this.notificationService.error(resp.messages[0]);
        }

        let url = resp.data.gameData.iframeUrl;
        let inputs = {
          iframeUrl: this.domSanitizer.bypassSecurityTrustResourceUrl(url),
          game: this.microGamingGame
        }
        this.modalService.init(GameComponent, inputs, {}, false, {
          modalElementId: 'my-game-modal',
          overlayElementId: 'my-game-modal-overlay'
        });
        this.overlayService.onOverlayChange(false);
      }, error => {
          console.log(error);
          this.notificationService.error(error);
      });
    }

  }
}



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/components/mg-wallet/mg-wallet.component.ts